
import { useState, useEffect, useRef } from 'react';

const faqs = [
  {
    question: 'Günde kaç saat takmalıyım?',
    answer: 'Şeffaf plaklar günde 20-22 saat takılı kalmalıdır. Yalnızca yemek yerken ve dişlerinizi fırçalarken çıkarabilirsiniz.'
  },
  {
    question: 'Sıcak içeceklerle kullanabilir miyim?',
    answer: 'Hayır, sıcak içecek tüketirken plağı mutlaka çıkarmanız gerekmektedir. Sıcaklık plağın şeklini bozabilir.'
  },
  {
    question: 'Plağım sarardı, ne yapmalıyım?',
    answer: 'Düzenli temizleme rutininizi uygulayın. Sararmaya karşı haftalık temizleme tableti kullanın. Geçmezse diş hekiminize danışın.'
  },
  {
    question: 'Ağrı hissetmek normal mi?',
    answer: 'İlk günlerde hafif baskı hissi normaldir. Bu, dişlerinizin hareket ettiğinin göstergesidir. Şiddetli ağrı durumunda hekiminize başvurun.'
  },
  {
    question: 'Plağımı kaybettim, ne yapmalıyım?',
    answer: 'Derhal diş hekiminizle iletişime geçin. Tedavi sürecinin aksamaması için yeni plak hazırlanması gerekebilir.'
  },
  {
    question: 'Spor yaparken takabilir miyim?',
    answer: 'Evet, çoğu spor aktivitesinde takabilirsiniz. Ancak kontakt sporlar için ek koruma gerekebilir.'
  }
];

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section 
      ref={sectionRef}
      id="faq" 
      className="py-20 section-padding bg-black/20"
    >
      <div className="container-max">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Sık Sorulan <span className="gold-text">Sorular</span>
          </h2>
          <div className="w-24 h-1 gold-gradient mx-auto rounded-full"></div>
          <p className="text-xl text-gray-300 mt-6 max-w-2xl mx-auto">
            Şeffaf plak tedavisi hakkında merak ettiğiniz soruların cevapları burada.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`accordion-item transition-all duration-700 ${
                isVisible ? 'slide-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div 
                className="accordion-header"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex items-center gap-4">
                  <div className="w-8 h-8 gold-gradient rounded-full flex items-center justify-center">
                    <i className="ri-question-line text-black font-bold"></i>
                  </div>
                  <h3 className="text-xl font-semibold">{faq.question}</h3>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl gold-text transition-transform duration-300 ${
                  openFAQ === index ? 'rotate-180' : ''
                }`}></i>
              </div>
              
              {openFAQ === index && (
                <div className="accordion-content">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mt-1">
                      <i className="ri-check-line text-[#D4AF37]"></i>
                    </div>
                    <p className="text-gray-300 leading-relaxed flex-1">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className={`text-center mt-16 transition-all duration-1000 delay-500 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
          <div className="card-premium max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold mb-4 gold-text">Başka Sorularınız Var mı?</h3>
            <p className="text-gray-300 mb-6">
              Burada bulamadığınız sorular için bizimle iletişime geçebilirsiniz.
            </p>
            <button 
              onClick={() => window.open('https://wa.me/905078064479', '_blank')}
              className="btn-primary micro-animation"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp'tan Sorun
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
